import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconTrashCan = props => (
  <SvgIcon {...props} viewBox="0 0 14 18">
    <path d="m1 16c0 1.1 0.9 2 2 2h8c1.1 0 2-0.9 2-2v-12h-12v12zm13-15h-3.5l-1-1h-5l-1 1h-3.5v2h14v-2z" />
  </SvgIcon>
);

export default IconTrashCan;



// WEBPACK FOOTER //
// ./src/components/icons/IconTrashCan.js